import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Configuration } from "../core/configuration";
import { ConfigurationLoader } from "../core/services/configuration-loader.service";

@Component({
    selector: "serprobots-assesment",
    templateUrl: "assesment.component.html",
    styleUrls: ["assesment.component.css"]
})
export class AssesmentComponent implements OnInit {

    @Output()
    onLikeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    onDislikeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    configuration: Configuration = new Configuration({});

    constructor(
        private configurationLoader: ConfigurationLoader
    ) {}

    async ngOnInit(): Promise<void> {
        this.configuration = await this.configurationLoader.getConfiguration();
    }

    getClass(): string {
        return `mat-typography ${this.configuration.typography || ""}`;
    }

    likeClicked(): void {
        this.onLikeClicked.emit(true);
    }

    dislikeClicked(): void {
        this.onDislikeClicked.emit(true);
    }

}